import { PureComponent } from 'react';
import { connect } from 'unistore/react';

import {
	actionsCombiner,
	tabFocusActions,
	tickerActions,
	convRatesActions,
} from '@utils/store/actions';

class BbRates extends PureComponent {
	componentDidMount() {
		this.connectOnFocus();
		this.updateRates();
		this.updateConvRates();
	}

	componentDidUpdate(prevProps) {
		const { isOnline, offlineOutTime, tabInFocus } = this.props;
		const offlineTimeoutInterval = Date.now() - offlineOutTime > 15000;

		if (prevProps.tabInFocus !== tabInFocus) {
			if (isOnline) {
				this.connectOnFocus();
			}
		}

		if (prevProps.isOnline !== isOnline) {
			if (isOnline) {
				if (offlineTimeoutInterval) {
					this.updateRates();
					this.connectOnFocus();
					this.updateConvRates();
				}
			} else if (offlineTimeoutInterval) {
				clearTimeout(this.updateRateCutOff);
				clearInterval(this.updateRateInterval);
				clearInterval(this.updateConvRateInterval);
			}
		}
	}

	componentWillUnmount() {
		clearInterval(this.updateRateInterval);
	}

	updateRates = () => {
		const { isOnline, __getTicker } = this.props;

		if (isOnline) {
			__getTicker();
		}
	};

	updateConvRates = () => {
		const { isOnline, __getConvRates } = this.props;

		if (isOnline) {
			__getConvRates();
		}
	};

	enableBehindTheScenes = () => {
		clearTimeout(this.updateRateCutOff);
		if (Date.now() - this.props.focusOutTime > 60000) {
			clearInterval(this.updateRateInterval);
			this.updateRates();
			this.updateConvRates();
			this.updateCurrentRateCaller(18000);
			this.updateConvRateCaller(300000);
		}
		if (
			typeof this.updateRateCutOff === 'undefined' ||
			typeof this.updateRateInterval === 'undefined' ||
			typeof this.updateConvRateInterval === 'undefined'
		) {
			this.updateCurrentRateCaller(18000);
			this.updateConvRateCaller(300000);
		}
	};

	disableBehindTheScenes = () => {
		this.updateRateCutOff = setTimeout(() => {
			clearInterval(this.updateConvRateInterval);
			clearInterval(this.updateRateInterval);
			this.updateCurrentRateCaller(120000);
		}, 60000);
	};

	updateCurrentRateCaller = interval => {
		this.updateRateInterval = setInterval(this.updateRates, interval);
	};

	updateConvRateCaller = interval => {
		this.updateConvRateInterval = setInterval(
			this.updateConvRates,
			interval
		);
	};

	connectOnFocus = () => {
		this.props.tabInFocus
			? this.enableBehindTheScenes()
			: this.disableBehindTheScenes();
	};

	render() {
		return null;
	}
}

export default connect(
	'tabInFocus, focusOutTime, isOnline',
	actionsCombiner(tabFocusActions, tickerActions, convRatesActions)
)(BbRates);
